import React from 'react';
import styles from './prenav-menu.scss';

const PrenavMenu = ({
  children,
  itemClassName,
  handler,
  keyboardHandler,
  menuLinks = [],
}) => {
  if (menuLinks?.length > 0) {
    return (
      <li className={itemClassName}>
        <h4 className={styles.menuLinksHeading}>{children}</h4>
        {menuLinks.map(item => (
          <a
            key={item.name}
            className={styles.menuLinksAnchors}
            href={item.url}
            {...(item.external && { target: '_blank', rel: 'noopener' })}
            onClick={handler}
            onKeyDown={keyboardHandler}
            data-test-id={item.name}
          >
            {item.name}
          </a>
        ))}
      </li>
    );
  }
  return null;
};

export default PrenavMenu;
